module.exports = __webpack_public_path__ + "static/img/xinyongka.0e940a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xinyongka.png
// module id = y9Lo
// module chunks = 128